import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
@Component({
  selector: 'app-button',
  template: `
    <ion-card-header>
      <h1 class="linha-horizontal">
        {{ field.label ? (field.label | translate) : '' }}
      </h1>
    </ion-card-header>
  `,
  styles: [
    `
      ion-card-header {
        padding: 20px 0;
      }

      .linha-horizontal {
        padding-top: 20px;
        padding-left: 30px;
      }

      h1 {
        color: var(--theme-color-segmentSelect);
      }
    `,
  ],
  standalone: true,
  imports: [
    TranslateModule,
    IonicModule,
    ReactiveFormsModule,
  ]
})
export class DividerComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
